import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SolicitudesService {
  public url: string;
  public identity;
  public token;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _http: HttpClient
  ) {
    this.url = GLOBAL.url;
   }

   getToken() {
    let token = localStorage.getItem('token');
    if (token !== 'undefined') {
        this.token = token;
    } else {
        this.token = null;
    }
    return this.token;
  }

  getTiposSolicitantesAperturados(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');//.set('Authorization', this.getToken())
    return this._http.get(this.url + 'get/solicitudes/tipos_solicitantes', { headers });
  }

  getDetalleUpaeg(idProductor): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/detalle/upaeg/'+idProductor, { headers });
  }


  getProgramasAbiertosUpaeg(idProductor): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/programas/upaeg/'+idProductor, { headers });
  }

  getApoyosDisponibles(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'presol/get/apoyos/disponibles/v3', { headers });
  }

  getSolicitantesDisponiblesForApoyo(ejercicio, programa, subprograma, apoyo): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/upaegs/apoyo/'+ejercicio+'/'+programa+'/'+subprograma+'/'+apoyo, { headers });
  }


  getDetallePresolConcepto(ejercicio, programa, subprograma, productor, idConcepto): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/upaeg/solicitud/detalle/V2/'+ejercicio+'/'+programa+'/'+subprograma+'/'+productor+'/'+idConcepto, { headers });
  }

  saveDocumento(parametros): Observable<any> {
    let headers = new HttpHeaders().set('Authorization', this.getToken());
    return this._http.post(this.url + 'save/documento/solicitud/V2', parametros, { headers });
  }


  getDocumentosEnlazadosPresolicitud(idProductor, idPresolicitud): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/documentos/presolicitud/'+idProductor+'/'+idPresolicitud, { headers });
  }

  getRequisitosDIpiniblesPresol(idProductor, idPresolicitud): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/requisitos/disponibles/presolicitud/'+idProductor+'/'+idPresolicitud, { headers });
  }

  getDetallePresolicitud(idProductor, idPresolicitud): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/detalle/presolicitud/'+idProductor+'/'+idPresolicitud+'/V2', { headers });
  }

  getRequisitosNoCumplidos(idProductor, idPresolicitud): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/validacion/documentos/presolicitud/'+idProductor+'/'+idPresolicitud, { headers });
  }


  getPresolicitudesUpaeg(idProductor): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/presolicitudes/'+idProductor, { headers });
  }

  deleteDocumentoSolicitud(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'delete/documento/solicitud', params, { headers });
  }

  getApoyosForSolicitud(idProductor, idPresolicitud): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/apoyos/for/presolicitud/' + idProductor + '/' + idPresolicitud, { headers });
  }

  savePresolicitud(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'save/pre/solicitud/v2', params, { headers });
  }


  getSistemasProductoRegistrados(ejercicio, idPresolicitud): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/sistemas/producto/presolicitud/' + idPresolicitud + '/' + ejercicio, { headers });
  }

  saveSistemaProducto(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'save/sistemaprod/solicitud', params, { headers });
  }

  deleteSistemaProducto(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'delete/sistemaprod/solicitud', params, { headers });
  }

  getPresolUpaeg(idProductor): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/presol/upaeg/' + idProductor, { headers });
  }

  getPresolStatus(idPresol): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/status/' + idPresol, { headers });
  }

  sendToValidation(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'send/validation/presolicitud', params, { headers });
  }


  validarEmailPresolicitud(code): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'validar/email/presol/' + code, { headers });
  }

  getBeneficiariosCampos(idPreCaptura = null): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    let parametros = '';
    if(idPreCaptura != null){
      parametros = '/'+idPreCaptura;
    }
    console.log(this.url + 'presol/get/presol/combinaciones'+parametros);
    return this._http.get(this.url + 'presol/get/presol/combinaciones'+parametros,  { headers });
  }


  saveEncuestaPresolicitud(params): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.post(this.url + 'set/encuesta/presolicitud', params, { headers });
  }

}
